<div *transloco="let t; read: TRANSLATION_SCOPE">
  <div class="text-center">
    <h3>{{ t('title') }}</h3>
    <p class="f-size-xs">
      {{ t('subtitle_1') }}
    </p>
    <p class="f-size-xs">{{ t('subtitle_2') }}</p>
  </div>
  <rx-alert
    *ngIf="authFacade.error$ | async as error"
    type="danger"
    class="mx-4"
    [message]="t('error.failed')"
    data-qa="test-auth-setup-mfa-error"
  ></rx-alert>
  <form class="px-4" (ngSubmit)="submit()">
    <rx-applications-phone-number-input
      [prefixLabel]="t('phone.prefixLabel')"
      [prefixPlaceholder]="t('phone.prefixPlaceholder')"
      [phoneLabel]="t('phone.phoneLabel')"
      [errorMessage]="t('phone.invalid')"
      [filterNoResultMessage]="t('phone.filterNoResultMessage')"
      [phoneNumberControl]="phoneNumberControl"
      (phoneChange)="phoneNumber.set($event)"
      data-qa="test-auth-setup-mfa-phone-input"
    />
    <rx-button
      buttonClass="primary"
      type="submit"
      data-qa="test-auth-setup-mfa-submit-btn"
      [flexible]="true"
      [disabled]="authFacade.isLoading$ | async"
    >
      <span *ngIf="(authFacade.isLoading$ | async) === false; else isLoading">{{ t('button.save') }}</span>
      <ng-template #isLoading>{{ t('button.saving') }}</ng-template>
    </rx-button>
  </form>
</div>
